import { Controller, FieldValues } from "react-hook-form";
import { FormTextField } from "../../FormTextField";
import { SharedControllerProps } from "../types";

interface TextFieldProps<
  T extends FieldValues = FieldValues,
> extends SharedControllerProps<T> {
  placeholder?: string;
  maxLength?: number;
  description?: string;
}

const TextField = <T extends FieldValues = FieldValues>({
  autoFocus,
  control,
  name,
  rules,
  label,
  maxLength,
  placeholder,
  description,
  disabled = false,
}: TextFieldProps<T>) => (
  <Controller
    control={control}
    name={name}
    rules={rules}
    render={({
      field: { name, value, onChange },
      fieldState: { invalid, error },
    }) => (
      <FormTextField
        label={label}
        placeholder={placeholder}
        name={name}
        maxLength={maxLength}
        value={value ?? ""}
        isInvalid={invalid}
        onChange={(val) => {
          // Trim leading spaces as user types
          const trimmed = val.replace(/^\s+/, "");
          onChange(trimmed);
        }}
        errorMessage={error?.message}
        autoFocus={autoFocus}
        description={description}
        isDisabled={disabled}
      />
    )}
  />
);

export default TextField;
